import React from 'react';
import { Box } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import { BodyText, Touchable } from '../../../ui';
import { useResponsiveEffect } from '../../../../hooks';

type HeaderServiceButtonProps = {
  category: string;
  onCategoryClick: (category: string) => void;
};

export default function HeaderServiceButton({
  category,
  onCategoryClick,
}: HeaderServiceButtonProps) {
  const is = useResponsiveEffect();
  return (
    <Touchable
      testID={`header-service-button-${category?.toLowerCase?.()}`}
      onClick={() => onCategoryClick(category)}
    >
      <Box
        paddingY={10}
        paddingX={20}
        borderWidth={0.5}
        borderRadius={4}
        borderStyle="solid"
        borderColor={BrandColor.Silver}
        minWidth={is.desktop ? 116 : 85}
        color={BrandColor.WhiteWash}
      >
        <BodyText
          textAlign="center"
          appearance={is.desktop ? 'normal' : 'small'}
        >
          {category}
        </BodyText>
      </Box>
    </Touchable>
  );
}
